module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8Kp65"))).then(() => module.bundle.root('dsisd'));